import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiTool } from 'react-icons/fi';

export default function Placeholder({ title }) {
  return (
    <motion.div 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        className="h-full flex flex-col items-center justify-center glass-panel"
    >
        <div className="p-6 rounded-full bg-[var(--surface-ocean-light)] border border-[var(--border-ocean)] mb-6 shadow-[0_0_30px_var(--schema-teal-dim)]">
             <SafeIcon icon={FiTool} className="text-4xl text-[var(--schema-teal)]" />
        </div>
        <h2 className="text-2xl font-bold text-[var(--pearl)] mb-2">{title} Module</h2>
        <p className="text-[var(--pearl-muted)] max-w-md text-center">
            This sector of the harbor is currently under construction. Dry dock engineers are actively working on deployment.
        </p>
    </motion.div>
  );
}